import React from 'react'
import { baseUrl } from 'utils/parseDomain'
import 'styles/footerLinks.scss'

function FooterLinks(props) {
  return (
    <div className="container text-center footerNavWrap">
      <div className="row">
        <div className="col-sm-3 navBlock">
          <div className="navHead">Need Help?</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/registration/user/login`}>Member Login</a>
            </li>
            <li>
              <a href={`${baseUrl}/registration/user`}>Sign Up</a>
            </li>
            <li>
              <a href={`${baseUrl}/search`}>Partner Search</a>
            </li>
            <li>
              <a
                href={`${baseUrl}/introduction/index/how-to-use`}
                target="_blank"
                rel="noopener noreferrer"
              >
                How to Use Shaadi.com
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/introduction/index/membership-plans`}>
                Premium Memberships
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/customer-relations/faq/registration`}>
                Customer Support
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/sitemap`}>Site Map</a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">Company</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/introduction/index/letter-from-cmd`}>
                About Us
              </a>
            </li>
            <li>
              <a
                href="http://blog.shaadi.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shaadi Blog
              </a>
            </li>
            <li>
              <a
                href="https://careers.shaadi.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Careers
              </a>
            </li>
            <li>
              <a
                href={`${baseUrl}/introduction/index/why-we-are-no1`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Awards &amp; Recognition
              </a>
            </li>
            <li>
              <a
                href="https://www.shaadi.com/cov-aid"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cov-Aid
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/contact-us`}>Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">Privacy &amp; You</div>
          <ul className="nav">
            <li>
              <a href={`${baseUrl}/shaadi-info/index/terms`}>Terms of Use</a>
            </li>
            <li>
              <a href={`${baseUrl}/shaadi-info/index/privacy`}>
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href={`${baseUrl}/customer-relations/faq/privacy-tips`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Be Safe Online
              </a>
            </li>
            <li>
              <a
                href="https://support.shaadi.com/support/tickets/new"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Report Misuse
              </a>
            </li>
          </ul>
        </div>
        <div className="col-sm-3 navBlock">
          <div className="navHead">More</div>
          <ul className="nav">
            <li>
              <a
                href="https://www.vipshaadi.in"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                VIP Shaadi
              </a>
            </li>
            <li>
              <a
                href="https://www.selectshaadi.com/select"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Select Shaadi
              </a>
            </li>
            <li>
              <a
                href="https://www.sangam.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Sangam
              </a>
            </li>
            <li>
              <a
                href="http://www.shaadicentre.in"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Shaadi Centres
              </a>
            </li>
            <li>
              <a
                href={`${baseUrl}/shaadi_info/matrimonial_success_stories/index.php`}
              >
                Success Stories
              </a>
            </li>
            <li>
              <a href={`${baseUrl}/meet`}>Shaadi Meet</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default FooterLinks
